// extracted by mini-css-extract-plugin
export default {"cross":"ModalTitle_cross__kc5BQ"};